import cn from 'classnames'
import React, { FC, ReactNode, useEffect, useState } from 'react'
import {
  DropdownList,
  getIcon,
  ILibDropdownItem,
  ILibHorizontalPosition,
  LibIconList,
  Popover
} from '@infologistics/frontend-libraries'

import { BrowserStorage, Instance, InstanceVar } from '@const/consts'
import { dropdownItems } from './consts'
import { getInstance, getDataFromLocalStorage, getInstanceVar } from '@utils/utils'

import styles from './ButtonInstance.module.css'

const getFlagName = (value: string): LibIconList => {
  if (value === Instance.RUSSIAN) return 'IconFlagRu'

  if (value === Instance.BRASIL) return 'IconFlagBr'

  if (value === Instance.SOUTH_AFRICA) return 'IconFlagZa'

  if (value === Instance.VIETNAMESE) return 'IconFlagVn'

  return 'IconFlagEn'
}

const getSpanMetrofile = () => <span style={{fontWeight: "bold"}}>Metrofile</span>

const getOptions = (dropdownItems: ILibDropdownItem[]): ILibDropdownItem[] => {
  return dropdownItems.map((val) => ({
    ...val,
    element: (
      <div className='d-flex align-items-center'>
        {getIcon(getFlagName(val.name.split("__")[0]))}
        {val.name.split("__")[1] === InstanceVar.METROFILE && getSpanMetrofile()}
        <span className='ml-1'>{val.translation}</span>
      </div>
    ),
  }));
};

const ButtonInstance: FC = () => {
  const [popoverOpened, setPopoverOpened] = useState<boolean>(false)
  const [selectedTitle, setSelectedTitle] = useState<LibIconList>('IconFlagEn')

  const instance = getDataFromLocalStorage(BrowserStorage.INSTANCE) as Instance ?? Instance.GLOBAL
  const cozaMetrofile = getInstanceVar() === InstanceVar.METROFILE;
  const fullInstance = instance + (cozaMetrofile ? ("__" + InstanceVar.METROFILE) : '')

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  useEffect(() => {
    setSelectedTitle(getFlagName(instance))
  }, [])


  const getSelectedItem = (items: ILibDropdownItem[]): ILibDropdownItem | undefined => items.find(({ name }) => name === fullInstance)

  const toggleClose = (isOpenFromPopover: boolean): void => {
    !isOpenFromPopover && setPopoverOpened(false)
  }

  const handleSelect = ({ name }: ILibDropdownItem): void => {
    const newName = name.split("__");
    setSelectedTitle(getFlagName(newName[0]))
    setPopoverOpened(false)

    const instance = getInstance(newName[0])
    window.localStorage.setItem(BrowserStorage.INSTANCE, instance)

    const instanceVar = newName[1] === InstanceVar.METROFILE ? InstanceVar.METROFILE : InstanceVar.DEFAULT;
    window.localStorage.setItem(BrowserStorage.INSTANCE_VAR, instanceVar)

    window.location.reload();
  }

  const getButton = (): ReactNode =>
    <div onClick={() => setPopoverOpened(!popoverOpened)} className='d-flex align-items-center'>
      {getIcon(selectedTitle, {size: isMobile ? 'lg' : 'base'})}
      {cozaMetrofile && getSpanMetrofile()}
    </div>

  return (
    <div
      className={cn(styles.wrapper, 'fixed')}
    >
      <Popover
        buttonComponent={getButton()}
        withoutArrow
        allowDropdownFlip
        horizontalPosition={ILibHorizontalPosition.RIGHT}
        parentManagement={{
          isOpenFromParent: popoverOpened,
          callbackForClose: toggleClose
        }}
      >
        <DropdownList
          dropdownItems={getOptions(dropdownItems)}
          onSelect={handleSelect}
          itemClasses='p-2'
          selectedItem={getSelectedItem(dropdownItems)}
        />
      </Popover>
    </div>
  )
}

export default ButtonInstance
